import { faSearch, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import ButtonLink from '../../../components/ButtonLink';
import Divider from '../../../components/Divider';
import Input from '../../../components/Input';
import { clientIdPage } from '../../../constants/pagesRoutesContants';
import { fetchContactClient } from '../../../services/contactClientService';
import UserType from '../../../types/UserType';
import styles from './style.module.scss';

function Clients() {
    const [clients, setClients] = useState<UserType[]>([]);

    const { data: clientsList } = useQuery({
        queryKey: ['contacts'],
        queryFn: async () => {
            try {
                const { data } = await fetchContactClient();
                setClients(data);
                return data || [];
            } catch (error) {
                console.log(error);
            }
            return [];
        },
    });

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchTerm = e.target.value.toLowerCase();

        if (clients) {
            if (searchTerm.length > 0) {
                const filteredCases =
                    clients?.filter(
                        (client: UserType) =>
                            client.firstName
                                ?.toLowerCase()
                                .includes(searchTerm) ||
                            client.lastName?.toLowerCase().includes(searchTerm)
                    ) || [];
                setClients(filteredCases);
            } else {
                setClients(clientsList);
            }
        }
    };

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>
                <span className={styles.headerIcon}>
                    <FontAwesomeIcon icon={faUsers} />
                </span>
                Clients
            </h1>
            <Divider marginBottom="20px" />
            <div className={styles.search}>
                <Input
                    type="text"
                    placeholder="Dossier, client, référence..."
                    onChange={handleSearch}
                    icon={faSearch}
                />
            </div>
            <div className={styles.clientsTable}>
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Client</th>
                            <th scope="col">Email</th>
                            <th scope="col">Téléphone</th>
                            <th scope="col">Dossiers</th>
                            <th scope="col">Statut</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody className={styles.events}>
                        {clients?.map((client: UserType) => (
                            <tr className={styles.event} key={client.id}>
                                <td className={styles.iconCol}>
                                    <FontAwesomeIcon icon={faUser} />
                                </td>
                                <td>
                                    {client.firstName}{' '}
                                    {client.lastName.toLocaleUpperCase()}
                                </td>
                                <td>{client.email}</td>
                                <td>{client.phone}</td>
                                <td></td>
                                <td></td>
                                <td>
                                    <ButtonLink
                                        link={clientIdPage.path + client.id}
                                    >
                                        Ouvrir
                                    </ButtonLink>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Clients;
